export default __webpack_public_path__ + "static/accents-avoid-yellow-dont-light-968594dae7887becc235c026eca49067a807f77aa1aeca2c9e4398473eadd427.png";